import React from 'react';

export default ({ className, ...other }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10.456" height="9.13" viewBox="0 0 10.456 9.13">
    <path
      d="M195.124,828.733a3.65,3.65,0,0,1-.6.813c-1.378,1.437-2.77,2.861-4.158,4.289-.04.041-.086.078-.146.132-.07-.065-.132-.117-.189-.176q-2.044-2.1-4.086-4.207a2.694,2.694,0,0,1-.633-3.3,2.658,2.658,0,0,1,4.689-.022c.036.062.063.13.1.194s.066.121.128.236a2.725,2.725,0,0,1,2.009-1.793,2.663,2.663,0,0,1,2.886,3.833Z"
      transform="translate(-184.996 -824.838)"
      fill="#fff"
    />
  </svg>
);
